import BaseService from "./BaseService";
import BaseFilter from './BaseFilter';

export class TenantLanguageService extends BaseService{
	constructor() {
		super('/TenantLanguage');
	}



	public getAllByFilter(filter: TenantLanguageFilter) {
		return super.getAllByFilterBase(filter);
	}

	public updateTenantLanguage(idTenant: number, tenantLanguage: any) {
		return super.updateBase(this._resourceName + '/update-tenant-language/' + idTenant, tenantLanguage);
	}
}

export class TenantLanguageFilter extends BaseFilter {
	constructor(idTenant?: number | null) {
		super();
		this._idTenant = idTenant;
	}

	private _idTenant?: number | null;
	

	public getAllParams(): {} {

		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {})
		);

		return data;
	};
}